// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Test_wrapper_3tvFd","testWrap":"Test_testWrap_15CFD","buttonWrapper":"Test_buttonWrapper_23Vo3"};